<template>
  <th>
    <a href="javascript:void(0);" v-on:click="$emit('sortChange',columnId)">{{columnName}}</a>
    <i v-if="this.$parent.sort==columnId && this.$parent.sort_direction == ''" class="fa fa-arrow-down pull-right"></i>
    <i v-if="this.$parent.sort==columnId && this.$parent.sort_direction == '-'" class="fa fa-arrow-up pull-right"></i>
  </th>
</template>

<script>
export default {
  name: 'ColumnSort',
  props: ['columnName', 'columnId'],
}
</script>


// WEBPACK FOOTER //
// src/components/ColumnSort.vue